<template>
  <div class="navigation__sub-menu" :class="{ 'active': active, 'hover': itemHovered }">
    <div>
      <div @mouseover="handleMouseOver" @mouseleave="handleMouseLeave" @click="!active && handleMouseLeave">
        <slot name="main"></slot>
      </div>

      <div v-show="active" class="navigation__sub-menu__items">
        <slot name="expanded"></slot>
      </div>
    </div>

    <q-popover ref="popover" anchor="top right" class="navigation__sub-menu__popover" :disable="active">
      <div @mouseover="handleMouseOver" @mouseleave="handleMouseLeave">
        <q-list no-border link>
          <slot name="popover"></slot>
        </q-list>
      </div>
    </q-popover>
  </div>
</template>

<script>
  export default {
    props: {
      active: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        itemHovered: false
      }
    },

    methods: {
      handleMouseOver () {
        this.itemHovered = true

        if (!this.active) {
          this.$refs.popover.show()
        }
      },

      handleMouseLeave () {
        this.itemHovered = false

        this.$nextTick(() => {
          if (!this.itemHovered) {
            this.$refs.popover.hide()
          }
        })
      }
    }
  }
</script>
